var exports = {
  "az": "Box__56Py9U",
  "wy": "Box_1__b8JkTG",
  "pv": "Box_2__Vw3c4O",
  "w9": "Box_3__eJgNAL",
  "DZ": "Heading__s2IBSH",
  "K0": "IconButton__bEmL5q",
};

module.exports = exports;
